module.exports = __webpack_public_path__ + "img/cprs_c.89ca3f1e.jpg";